<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light mb-5">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="mostrar()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link to="./config" class="navbar-brand">Configuración</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/productos" class="navbar-brand">Banners</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/side-offer" class="navbar-brand">Side Offer</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/palabras" class="navbar-brand">Malas Palabras</router-link>
        </li>
        <li class="nav-item ">
          <router-link to="/chat" class="navbar-brand">Chat</router-link>
        </li>
        <li class="nav-item ">
          <router-link to="/ban" class="navbar-brand">Baneo de usuarios</router-link>
        </li>

        <!-- <li class="nav-item ">
          <router-link to="/anfitrion" target="_blank" class="navbar-brand">Anfitrión</router-link>
        </li> -->
        <li class="nav-item ">
          <router-link to="/live-debug" class="navbar-brand">Live Test</router-link>
        </li>
        <li class="nav-item ">
          <router-link to="/?origen=samsung" target="_blank" class="navbar-brand">
            Usuario samsung
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "menuAdmin",
  methods:{
    mostrar(){
      let para = document.getElementById("navbarNav");
      para.classList.toggle("show");
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  margin-left: -15px;
  margin-right: -15px;
}

nav a.navbar-brand {
  font-size: 1.2em;
}

nav a.navbar-brand:hover {
  color: #333;
  text-decoration: underline;
}
nav li a{
  color: #333;
  font-size: 1.2em;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
}
nav li a:hover,
nav li a.router-link-active,
nav li a.router-link-exact-active {
  color: #333;
  font-size: 1.2em;
  font-weight: 600;
}
@media only screen and (max-width: 480px) {
}
</style>